import routerOptions0 from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.4.8_@azure+identity@4.13.0_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@_00b3dff35a68ba611337aee823d6f564/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}